<template>
  <div class="w-full" :key="order.updated_at">
    <portal to="search">
      <div class="flex items-center">
        <h1 class="font-bold text-lg md:text-2xl">
          <inertia-link
            class="text-indigo-400 hover:text-indigo-600"
            :href="route('customer.orders')"
          >
            Customer Orders
          </inertia-link>
          <span class="text-indigo-400 font-medium">/</span>
          Order #{{ order.id }}
        </h1>
      </div>
    </portal>

    <div class="grid grid-cols-1 sm:grid-cols-12 gap-6">
      <div class="sm:col-span-12">
        <div>
          <OrderTabs active="activity" :order-id="order.id" />
          <OrderTabContent>
            <OrderHistory :activities="activities" :is-super-admin="isSuperAdmin"/>
          </OrderTabContent>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from "../../../Shared/Admin/Layout.vue";
import OrderTabs from "./Partials/OrderTabs.vue";
import OrderTabContent from "./Partials/OrderTabContent.vue";
import OrderHistory from "./OrderHistory.vue";

export default {
  name: 'DeliveryDetails',
  components: {OrderHistory, OrderTabContent, OrderTabs},
  layout: Layout,
  metaInfo: { title: 'Order Activities' },
  props: {
    order: Object,
    activities: Object,
    isSuperAdmin: Boolean,
  }
}
</script>
